import { Axios } from "../lib/axios";
export const HelpServices = {
  get,
};
function get(url) {
  return Axios.get(url);
}
